<template>
    <div>
        SRG Uploaded Documents
        <v-btn
            icon
            x-small
            class="ml-6 primary--text d-inline"
            :style="refresh_delivs ? 'border:none' : 'border:1px solid #0096A6'"
            :loading="refresh_delivs"
            @click="refreshDelivs()">
            <v-icon v-if="!refresh_delivs"
                small
                class="primary--text">
                mdi-autorenew
            </v-icon>
        </v-btn>
        <div class="d-inline ml-3">{{ projectDeliverables.dlvs.length }} file{{ projectDeliverables.dlvs.length == 1 ? '':'s' }}</div>

        <v-data-table
            v-if="projectDeliverables.dlvs.length"
            :headers="dlv_headers"
            :items="projectDeliverables.dlvs"
            :loading="refresh_delivs"
            disable-pagination
            hide-default-footer>
            
            <template v-slot:header="{ headers }">
                <thead>
                    <tr>
                        <td v-for="column in headers" :key="column.value">
                            {{column.text}}
                        </td>
                    </tr>
                </thead>
            </template>

            <template v-slot:body="{ items }">
                <tbody name="list" is="transition-group">
                    <tr v-for="item in items" :key="item.key" class="item-row avenir_book">
                        <td class="text-start">
                            <a v-if="item.received == null" @click="confirmReceivedDoc(item)">{{ item.file_name }}</a>
                            <a v-else :href="item.url" class="clean_link" target="_blank">{{ item.file_name }}</a>
                        </td>
                        <td class="text-start" width="20%">{{ item.received != null ? formatDate(item.received, 'mediumDate') : 'N/A' }}</td>
                        <td class="text-start" width="14%">{{ formatDate(item.file_upload_date, 'mediumDate') }}</td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>

        <v-dialog 
            v-model="confirmDialog" 
            width="44%"
            elevation="8"
        >
            <v-card>
                <v-card-title class="sansation_subtitle primary darken-3 white--text">
                    Please confirm that you have received this document.
                </v-card-title>
                <v-card-text class="px-10 py-9 d-flex avenir_book disclaimer">
                    <v-checkbox
                        :disabled="confirm_enabled"
                        hide-details
                        @click="confirmChecked()"
                        class="mx-4 mt-0">
                    </v-checkbox>
                    By checking this box and clicking the button below you confirm to have received this document provided by Succession Resource Group in fullfilment of our obligation to deliver a report for the {{ deliverable_received_item.module_name }} service we have entered into an agreement together on.
                </v-card-text>
                 <v-divider></v-divider>
                <v-card-actions class="pa-3 px-6">
                    <v-spacer></v-spacer>
                    <v-btn 
                        outlined
                        elevation="1"
                        color="primary"
                        :disabled="download_disabled"
                        @click="downloadDoc(deliverable_received_item)">
                        Download Document
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>


<script>  
    import dateFormat, { masks } from "dateformat";

    export default {
        name: 'ProjectDeliverables',

        props: {
            projectDeliverables: {},
            refresh_delivs: Boolean,
            pullProjectDelivs: Function,
            confirmedDeliverable: Function
        },

        data () {
            return {
                confirmDialog: false,
                confirm_enabled: false,
                download_disabled: true,
                deliverable_received_item: {},
                dlv_headers: [
                    {   text: 'File Name',     
                        value: 'file_name',    
                        align: 'start',  
                        sortable: true 
                    },
                    {   text: 'Download Date',     
                        value: 'received',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Uploaded',     
                        value: 'file_upload_date',
                        align: 'left',    
                        sortable: true 
                    }
                ]
            }
        },

        watch: {
            refresh_delivs (val) {
                this.refresh_delivs = val;
            }
        },
        
        methods: {
            formatDate: function ( date, mask ) {
                return dateFormat(date, mask)
            },

            refreshDelivs: function () {
                this.$emit('pullProjectDelivs', this.projectDeliverables );
            },

            confirmReceivedDoc: function ( item ) {
                // console.log(item)
                this.confirmDialog = true;
                item.module_name = this.projectDeliverables.module_name
                this.deliverable_received_item = item
            },

            confirmChecked: function () {
                this.confirm_enabled = !this.confirm_enabled;
                this.download_disabled = !this.download_disabled
            },

            downloadDoc: function ( data ) {
                this.$emit('confirmedDeliverable', data );

                setTimeout(() => {
                    window.open(data.url)
                    this.confirmDialog = false;
                    this.refreshDelivs();
                }, 500)
            }
        },

        mounted () {
            // console.log(this.projectDeliverables.dlvs)
        }
    }
</script>

<style scoped>
    .disclaimer {
        font-size: 1rem !important;
    }
    .clean_link {
        text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectDeliverables.vue